import React from 'react';
import cn from 'classnames';
import styles from './Navigation.module.scss';
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { Auth } from 'aws-amplify';

export default function Navigation(props) {

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  async function signOut() {
    try {
        await Auth.signOut({ global: true });
        localStorage.clear();
        localStorage.removeItem('checkedId');
        localStorage.removeItem('selectedId');
        localStorage.setItem('isSignOut', true);
        window.location.pathname = "/signin";
    } catch (error) {
        console.log('error signing out: ', error);
    }
}

  return (
    <div className={`navigations ${cn(styles.content_box, styles.content_box_layout)}`}>
      <ul>
      <img className={cn(styles.box5)} src={require('assets/ic_close_circle.svg').default} alt="Rectangle 36" onClick={()=>props.navState(null)} />

      <div className={cn(styles.block2, styles.block2_layout)}>
        
        <li>
  
        <Link to="/myFleet" className={splitLocation[1] === "myFleet" ? cn(styles.subtitle, styles.subtitle_layout) : cn(styles.text1)}>
        {/* <div className={cn(styles.block2_item)}> */}
        <img src={require('assets/ic_directions_bus_48px.svg').default} alt="assets/ic_directions_bus_48px.svg" className={cn(styles.box1, styles.box1_layout,styles.spaceList)} />
          
        {/* </div> */}
        {/* <div className={cn(styles.block2_spacer)} />   */}
        {'My Fleet'}
          </Link>
         
        </li>
      </div>

      <div className={cn(styles.block2, styles.block2_layout)}>
        {/* <div className={cn(styles.block2_item)}>
        <img src={require('assets/ic_ev_station_48px.svg').default} alt="assets/ic_ev_station_48px.svg" className={cn(styles.box1, styles.box1_layout,styles.spaceList)} />
        </div>
        <div className={cn(styles.block2_spacer)} /> */}
        <li>
        <Link to="/myChargers" className={splitLocation[1] === "myChargers" ? cn(styles.subtitle, styles.subtitle_layout) : cn(styles.text1)}>
        <img src={require('assets/ic_ev_station_48px.svg').default} alt="assets/ic_ev_station_48px.svg" className={cn(styles.box1, styles.box1_layout,styles.spaceList)} />
          {'My Chargers'}
          </Link>
        </li>
      </div>

      <div className={cn(styles.block2, styles.block2_layout)}>
        {/* <div className={cn(styles.block2_item)}>
          <img src={require('assets/Icon awesome-chart-bar.svg').default} alt="assets/Icon awesome-chart-bar.svg" className={cn(styles.box1, styles.box1_layout)} />
        </div>
        <div className={cn(styles.block2_spacer)} /> */}
        <li>
          <Link to="/reports" className={splitLocation[1] === "reports" ? cn(styles.subtitle, styles.subtitle_layout) : cn(styles.text1)}>
          <img src={require('assets/Icon awesome-chart-bar.svg').default} alt="assets/Icon awesome-chart-bar.svg" className={cn(styles.box1, styles.box1_layout,styles.spaceListR)} />
            {'My Reports'}
            </Link>
        </li>
      </div>

      {/* <div className={cn(styles.block2, styles.block2_layout)}>
        <div className={cn(styles.block2_item)}>
          <img src={require('assets/Icon ionic-md-settings.svg').default} alt="assets/Icon ionic-md-settings.svg" className={cn(styles.box1, styles.box1_layout)} />
        </div>
        <div className={cn(styles.block2_spacer)} />
        <li>
          <Link to="/settings" className={splitLocation[1] === "settings" ? cn(styles.subtitle, styles.subtitle_layout) : cn(styles.text1)}>{'My Settings'}</Link>
        </li>
      </div> */}

      <div className={cn(styles.block2, styles.block2_layout)}>
        <div className={cn(styles.block2_item)}>
          {/* <img src={require('assets/Icon material-account-box.svg').default} alt="assets/Icon material-account-box.svg" className={cn(styles.box1, styles.box1_layout)} /> */}
        </div>
        <div className={cn(styles.block2_spacer)} />
        {/* <li>
          <Link to="#" className={splitLocation[1] === "myAccount" ? cn(styles.subtitle, styles.subtitle_layout) : cn(styles.text1)}>{'My Account'}</Link>
        </li> */}
      </div>

      <div className={cn(styles.block2, styles.block2_layout)}>
        <div className={cn(styles.block2_item)}>
          {/* <img src={require('assets/Icon material-account-box.svg').default} alt="assets/Icon material-account-box.svg" className={cn(styles.box1, styles.box1_layout)} /> */}
        </div>
        <div className={cn(styles.block2_spacer)} />
        {/* <li>
          <Link to="#" className={splitLocation[1] === "TripAndChargeSchedule" ? cn(styles.subtitle, styles.subtitle_layout) : cn(styles.text1)}>{'My Schedule'}</Link>
        </li> */}
      </div>


      <div className={cn(styles.bottom_block)}>
      {/* <div className={cn(styles.block3, styles.block3_layout)}>
        <div className={cn(styles.block3_item)}>
          <img src={require('assets/Icon material-supervisor-account.svg').default} alt="assets/Icon material-account-box.svg" className={cn(styles.box2, styles.box2_layout)} />
        </div>
        <div className={cn(styles.block3_spacer)} />
        <h4 className={cn(styles.text1, styles.highlights_layout)}>
          {'Admin'}
        </h4>
      </div> */}

      <div className={cn(styles.block3, styles.block3_layout, styles.text2)}>
        Version 2.0.0
      </div>

      <hr className={cn(styles.line, styles.line_layout)} />

      <div className={cn(styles.block4, styles.block4_layout)}>
        <div className={cn(styles.block4_item)}>
          <img src={require('assets/Icon material-live-help.svg').default} alt="assets/ic_directions_bus_48px.svg" className={cn(styles.box1, styles.box1_layout)} />
        </div>
        <div className={cn(styles.block4_spacer)} />
        <a href='http://support.nuvve.com/' target="_blank" className={cn(styles.text1)}>
        <h4 className={cn(styles.text2)}>
          {'Get Help'}
        </h4>
        </a>
      </div>

      <div className={cn(styles.block5, styles.block5_layout)}>
        <div className={cn(styles.block5_item)}>
          <img src={require('assets/Group 4841.svg').default} alt="assets/ic_directions_bus_48px.svg" className={cn(styles.box1, styles.box1_layout)} />
        </div>
        <div className={cn(styles.block5_spacer)} />
        <li className={cn(styles.highlights)}>
          <Link to="#" onClick={signOut} className={cn(styles.text2)}>{'Sign Out'}</Link>
        </li>
      </div>
      </div>
      </ul>
    </div>
  );
}
